import t from '@jetshop/intl';
import Accordion from '@jetshop/ui/Accordion/Accordion';
import ProductSpecifications from '@jetshop/ui/ProductSpecifications/ProductSpecifications';
import React, { Fragment } from 'react';
import styled from 'react-emotion';
import ProductDescription from './ProductDescription';
import { StyledCarrot } from '@jetshop/ui/Select/Components';
const Description = styled(ProductDescription)``;

const AccordionWrapper = styled('div')`
  margin-bottom: 40px;
  width: 100%;
`;
const ProductSection = styled('div')`
  background-color: #ffffff;
  padding: 0px 20px;
  tr {
    border-top: 1px solid #dfdfdf;
  }
  margin-bottom: 1px;
`;

const SectionHeading = styled('button')`
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  font-size: 14px;
  margin-bottom: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Content = styled('div')`
  padding: 1rem 0;
`;

const ProductInfoAccordion = ({
  description,
  specifications,
  geometryTablePage,
  sizeGuidePage
}) => {
  return (
    <AccordionWrapper>
      <Accordion single>
        {({ openIndexes, handleClick, AccordionContent }) => (
          <Fragment>
            {description && (
              <ProductSection>
                <SectionHeading onClick={() => handleClick(0)}>
                  <span>{t('Product description')}</span>
                  <StyledCarrot open={openIndexes.includes(0)} />
                </SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(0)}>
                  <Description description={description} />
                </AccordionContent>
              </ProductSection>
            )}
            {specifications && (
              <ProductSection>
                <SectionHeading onClick={() => handleClick(1)}>
                  <span>{t('Specifications')}</span>
                  <StyledCarrot open={openIndexes.includes(1)} />
                </SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(1)}>
                  <ProductSpecifications fields={specifications} />
                </AccordionContent>
              </ProductSection>
            )}
            {geometryTablePage && geometryTablePage.page && (
              <ProductSection>
                <SectionHeading onClick={() => handleClick(2)}>
                  <span>{t('Geometry table')}</span>
                  <StyledCarrot open={openIndexes.includes(2)} />
                </SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(2)}>
                  <Content
                    dangerouslySetInnerHTML={{
                      __html: geometryTablePage.page.content
                    }}
                  />
                </AccordionContent>
              </ProductSection>
            )}
            {sizeGuidePage && sizeGuidePage.page && (
              <ProductSection>
                <SectionHeading onClick={() => handleClick(3)}>
                  <span>{t('Size guide')}</span>
                  <StyledCarrot open={openIndexes.includes(3)} />
                </SectionHeading>
                <AccordionContent isOpen={openIndexes.includes(3)}>
                  <Content
                    dangerouslySetInnerHTML={{
                      __html: sizeGuidePage.page.content
                    }}
                  />
                </AccordionContent>
              </ProductSection>
            )}
          </Fragment>
        )}
      </Accordion>
    </AccordionWrapper>
  );
};

export default ProductInfoAccordion;
